import React from "react";

const ArticleButton = () => {
  return (
    <a href="#" className="article-button">
      CITEŞTE MAI MULT &rarr;
    </a>
  );
};

export default ArticleButton;
